import { theme } from '@notino/react-styleguide'
import styled from 'styled-components'

// styles
import { NotinoLabelSmall400 } from '../../../../styles/helpers'

export const RatingsList = styled.dl`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	margin: 0;
`

export const RatingWrapper = styled.div`
	display: flex;
	gap: 0.75rem;
	align-items: center;
`

export const ProgressLineWithCount = styled.dd`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex: 1;
	margin: 0;
	position: relative;
`

export const Count = styled.span`
	${NotinoLabelSmall400};
	display: inline-block;
	flex-shrink: 0;
	text-align: right;
`
export const ProgressBarContainer = styled.div`
	height: 0.25rem;
	width: calc(100% - 2rem); // 100% - space for the label
	background-color: ${theme.color.common.gray90};
	border-radius: 9999px;
`

export const Progress = styled.div<{ $progress: number }>`
	width: ${({ $progress }) => $progress}%;
	height: 100%;
	background-color: ${theme.color.background.inverse};
	border-radius: 9999px;
`

export const RatingValue = styled.dt`
	display: flex;
	align-items: center;
	gap: 0.25rem;
	margin: 0;
	position: relative;
`

export const RatingValueText = styled.span`
	${theme.typography.labelRegular400};
	color: ${theme.color.text.secondary};
`
